import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { Muscle } from '@chiroup/core/types/Muscle.type';

const muscleService = () => {
  const list = async (clinicId?: number): Promise<{ data: Muscle[] }> => {
    return ChiroUpAPI.get('api', `/${clinicId}/muscle`, {});
  };

  return {
    list,
  };
};

export default muscleService();
